import React, { useMemo } from "react";
import useWebHomePhoto from "../hooks/useWebHomePhoto";

function shuffleArray(arr) {
  // Fisher-Yates shuffle
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function SliderImages({ children }) {
  const { ilkFoto, fotograflar, loading, error } = useWebHomePhoto();

  // ilkFoto'yu başa koy, fotografları rastgele sırala, ilkFoto'yu fotograflardan çıkar
  const images = useMemo(() => {
    if (!ilkFoto || !ilkFoto.url) return [];
    const filtered = fotograflar.filter(f => f.url !== ilkFoto.url);
    const shuffled = shuffleArray(filtered);
    return [ilkFoto, ...shuffled];
  }, [ilkFoto, fotograflar]);

  if (loading || !ilkFoto) return null;
  if (error) return null;

  if (typeof children === "function") {
    return children(images);
  }
  return null;
}